module.exports = __webpack_public_path__ + "public/SiteIcons/nonRefundable.svg?e4d87a3f";